import { useTranslation } from "react-i18next";
import { Spinner } from "@/components/ui/spinner";

export default function LoginSessionLoading() {
  const { t } = useTranslation(["auth"]);
  return (
    <div className="min-h-[100dvh] bg-[var(--background)] px-4 py-12">
      <div className="mx-auto w-full max-w-md">
        <div className="rounded-[var(--r-lg)] border border-[var(--border)] bg-[var(--card)] p-8 text-center shadow-[var(--sh-md)]">
          <Spinner
            aria-label={t("auth:login.checkingSession")}
            className="mx-auto h-8 w-8 text-[var(--primary)]"
          />
          <p className="mt-4 text-sm text-[var(--muted-foreground)]">{t("auth:login.checkingSession")}</p>
        </div>
      </div>
    </div>
  );
}
